(function () {
  var GUEST_KEY = 'lusso_wishlist_guest';
  var LEGACY_KEY = 'lusso_wishlist';
  var mergeDone = false;

  function getCustomerInfo() {
    try {
      var el = document.getElementById('WishlistCustomerData');
      if (!el) return { loggedIn: false, id: null };
      var data = JSON.parse(el.textContent);
      return { loggedIn: !!data.loggedIn, id: data.id || null };
    } catch (e) {
      return { loggedIn: false, id: null };
    }
  }

  function getProductPageData() {
    try {
      var el = document.getElementById('WishlistProductData');
      if (!el) return null;
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function getStorageKey() {
    var customer = getCustomerInfo();
    if (customer.loggedIn && customer.id) {
      return 'lusso_wishlist_customer_' + customer.id;
    }
    return GUEST_KEY;
  }

  function readKey(key) {
    try {
      var raw = localStorage.getItem(key);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function mergeGuestIntoCustomerOnLogin() {
    if (mergeDone) return;
    mergeDone = true;
    var customer = getCustomerInfo();
    if (!customer.loggedIn || !customer.id) return;

    var customerKey = 'lusso_wishlist_customer_' + customer.id;
    var guestItems = readKey(GUEST_KEY);
    var legacyItems = readKey(LEGACY_KEY);
    var toMerge = guestItems.concat(legacyItems);
    if (toMerge.length === 0) return;

    var customerItems = readKey(customerKey);
    toMerge.forEach(function (item) {
      if (!customerItems.some(function (i) { return String(i.id) === String(item.id); })) {
        customerItems.unshift(item);
      }
    });
    localStorage.setItem(customerKey, JSON.stringify(customerItems));
    localStorage.removeItem(GUEST_KEY);
    localStorage.removeItem(LEGACY_KEY);
  }

  function getWishlist() {
    return readKey(getStorageKey());
  }

  function saveWishlist(items) {
    localStorage.setItem(getStorageKey(), JSON.stringify(items));
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { items: items } }));
  }

  function isInWishlist(id) {
    return getWishlist().some(function (item) {
      return String(item.id) === String(id);
    });
  }

  function addToWishlist(item) {
    var items = getWishlist();
    if (!items.some(function (i) { return String(i.id) === String(item.id); })) {
      items.unshift(item);
      saveWishlist(items);
    }
  }

  function removeFromWishlist(id) {
    var items = getWishlist().filter(function (i) {
      return String(i.id) !== String(id);
    });
    saveWishlist(items);
  }

  function toggleWishlist(item) {
    if (isInWishlist(item.id)) {
      removeFromWishlist(item.id);
      return false;
    }
    addToWishlist(item);
    return true;
  }

  function escapeHtml(value) {
    return (value || '').toString().replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function buildProductButton(product) {
    var wrapper = document.createElement('div');
    wrapper.className = 'product-wishlist-wrapper';
    wrapper.innerHTML =
      '<button type="button" class="wishlist-heart-button product-wishlist-button" ' +
        'data-wishlist-id="' + escapeHtml(product.id) + '" ' +
        'data-wishlist-handle="' + escapeHtml(product.handle) + '" ' +
        'data-wishlist-title="' + escapeHtml(product.title) + '" ' +
        'data-wishlist-image="' + escapeHtml(product.image) + '" ' +
        'data-wishlist-price="' + escapeHtml(product.price) + '" ' +
        'data-wishlist-url="' + escapeHtml(product.url) + '" ' +
        'aria-pressed="false" aria-label="Add to wishlist">' +
        '<svg class="icon-wishlist-heart" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" aria-hidden="true">' +
          '<path d="M12 20.5s-7.5-4.6-10-9.3C.6 8 1.8 4.5 5 3.4c2.3-.8 4.6.1 6 2 1.4-1.9 3.7-2.8 6-2 3.2 1.1 4.4 4.6 3 7.8-2.5 4.7-10 9.3-10 9.3z"/>' +
        '</svg>' +
        '<span class="product-wishlist-button__label">Add to Wishlist</span>' +
      '</button>';
    return wrapper;
  }

  function findProductInfoContainer() {
    return document.querySelector('[id^="ProductInfo-"]') ||
      document.querySelector('.product__info-container') ||
      document.querySelector('[id^="MainProduct-"]') ||
      null;
  }

  function initProductPageButton() {
    if (document.querySelector('.product-wishlist-wrapper')) return;
    var product = getProductPageData();
    if (!product) return;

    var anchor = document.querySelector('.product__title') ||
      document.querySelector('.product-form__buttons') ||
      document.querySelector('.price-wrapper');
    if (!anchor) return;

    var button = buildProductButton(product);
    anchor.insertAdjacentElement('afterend', button);
    ensureProductButtonPersists();
  }

  var productObserverAttached = false;

  function ensureProductButtonPersists() {
    if (productObserverAttached) return;
    var container = findProductInfoContainer();
    if (!container || typeof MutationObserver === 'undefined') return;
    productObserverAttached = true;

    var pending = false;
    var observer = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      setTimeout(function () {
        pending = false;
        if (getProductPageData() && !document.querySelector('.product-wishlist-wrapper')) {
          initProductPageButton();
          updateHeartButtons();
        }
      }, 60);
    });
    observer.observe(container, { childList: true, subtree: true });
  }

  function updateHeartButtons() {
    var ids = getWishlist().map(function (i) { return String(i.id); });
    document.querySelectorAll('.wishlist-heart-button[data-wishlist-id]').forEach(function (btn) {
      var active = ids.indexOf(String(btn.getAttribute('data-wishlist-id'))) !== -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
      var label = btn.querySelector('.product-wishlist-button__label');
      if (label) label.textContent = active ? 'Added to Wishlist' : 'Add to Wishlist';
    });
  }

  function updateCountBubble() {
    var count = getWishlist().length;
    document.querySelectorAll('#WishlistCount').forEach(function (el) { el.textContent = count; });
    document.querySelectorAll('#WishlistCountBubble').forEach(function (el) {
      el.style.display = count > 0 ? '' : 'none';
      el.classList.toggle('cart-count-max', count >= 100);
    });
  }

  function renderDrawer() {
    var items = getWishlist();
    var container = document.getElementById('WishlistDrawer-Items');
    var emptyState = document.getElementById('WishlistDrawer-Empty');
    var countEl = document.getElementById('WishlistDrawer-Count');
    if (countEl) countEl.textContent = items.length;
    if (!container) return;

    if (items.length === 0) {
      container.innerHTML = '';
      if (emptyState) emptyState.hidden = false;
      return;
    }
    if (emptyState) emptyState.hidden = true;

    container.innerHTML = items.map(function (item) {
      var img = item.image
        ? '<img class="wishlist-item__image" src="' + item.image + '" alt="' + escapeHtml(item.title) + '" width="80" height="80" loading="lazy">'
        : '';
      return (
        '<div class="wishlist-item" data-wishlist-item="' + item.id + '">' +
          '<a href="' + item.url + '" class="wishlist-item__link">' + img + '</a>' +
          '<div class="wishlist-item__details">' +
            '<a href="' + item.url + '" class="wishlist-item__title">' + escapeHtml(item.title) + '</a>' +
            '<div class="wishlist-item__price">' + (item.price || '') + '</div>' +
          '</div>' +
          '<button type="button" class="wishlist-item__remove" data-wishlist-remove="' + item.id + '" aria-label="Remove from wishlist">&times;</button>' +
        '</div>'
      );
    }).join('');
  }

  function renderPage() {
    var items = getWishlist();
    var grid = document.getElementById('WishlistPage-Grid');
    var emptyState = document.getElementById('WishlistPage-Empty');
    if (!grid) return;

    if (items.length === 0) {
      grid.innerHTML = '';
      grid.hidden = true;
      if (emptyState) emptyState.hidden = false;
      return;
    }
    grid.hidden = false;
    if (emptyState) emptyState.hidden = true;

    grid.innerHTML = items.map(function (item) {
      var img = item.image
        ? '<img src="' + item.image + '" alt="' + escapeHtml(item.title) + '" loading="lazy" width="400" height="400">'
        : '';
      return (
        '<div class="wishlist-page-card" data-wishlist-item="' + item.id + '">' +
          '<button type="button" class="wishlist-page-card__remove" data-wishlist-remove="' + item.id + '" aria-label="Remove from wishlist">&times;</button>' +
          '<a href="' + item.url + '" class="wishlist-page-card__media">' + img + '</a>' +
          '<div class="wishlist-page-card__info">' +
            '<a href="' + item.url + '" class="wishlist-page-card__title">' + escapeHtml(item.title) + '</a>' +
            '<div class="wishlist-page-card__price">' + (item.price || '') + '</div>' +
            '<a href="' + item.url + '" class="button button--secondary wishlist-page-card__cta">View Product</a>' +
          '</div>' +
        '</div>'
      );
    }).join('');
  }

  function refreshAll() {
    mergeGuestIntoCustomerOnLogin();
    initProductPageButton();
    updateHeartButtons();
    updateCountBubble();
    renderDrawer();
    renderPage();
  }

  document.addEventListener('click', function (event) {
    var heartBtn = event.target.closest && event.target.closest('.wishlist-heart-button');
    if (heartBtn) {
      event.preventDefault();
      event.stopPropagation();
      toggleWishlist({
        id: heartBtn.getAttribute('data-wishlist-id'),
        handle: heartBtn.getAttribute('data-wishlist-handle'),
        title: heartBtn.getAttribute('data-wishlist-title'),
        image: heartBtn.getAttribute('data-wishlist-image'),
        price: heartBtn.getAttribute('data-wishlist-price'),
        url: heartBtn.getAttribute('data-wishlist-url')
      });
      return;
    }

    var removeBtn = event.target.closest && event.target.closest('[data-wishlist-remove]');
    if (removeBtn) {
      event.preventDefault();
      removeFromWishlist(removeBtn.getAttribute('data-wishlist-remove'));
    }
  });

  document.addEventListener('wishlist:updated', refreshAll);
  document.addEventListener('DOMContentLoaded', refreshAll);
  document.addEventListener('shopify:section:load', refreshAll);
  document.addEventListener('change', function (event) {
    if (event.target && event.target.closest && event.target.closest('variant-selects, variant-radios, product-form, [id^="ProductInfo-"]')) {
      setTimeout(refreshAll, 150);
    }
  });

  window.LussoWishlist = {
    get: getWishlist,
    add: addToWishlist,
    remove: removeFromWishlist,
    toggle: toggleWishlist,
    isInWishlist: isInWishlist
  };
})();

class WishlistDrawer extends HTMLElement {
  constructor() {
    super();
    this.overlay = this.querySelector('#WishlistDrawer-Overlay');
    if (this.overlay) this.overlay.addEventListener('click', this.close.bind(this));
    this.addEventListener('keyup', function (evt) {
      if (evt.code === 'Escape') this.close();
    }.bind(this));

    var trigger = document.getElementById('wishlist-icon-bubble');
    if (trigger) {
      trigger.setAttribute('role', 'button');
      trigger.setAttribute('aria-haspopup', 'dialog');
      var self = this;
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        if (!self.classList.contains('active')) self.open(trigger);
        else self.close();
      });
    }
  }

  open(triggeredBy) {
    if (triggeredBy) this.activeElement = triggeredBy;
    this.classList.add('animate', 'active');
    document.body.classList.add('overflow-hidden-drawer');
    var self = this;
    this.addEventListener('transitionend', function () {
      var focusElement = self.querySelector('.drawer__inner') || self.querySelector('.drawer__close');
      if (typeof trapFocus === 'function') trapFocus(document.getElementById('WishlistDrawer'), focusElement);
    }, { once: true });
  }

  close() {
    this.classList.remove('active');
    document.body.classList.remove('overflow-hidden-drawer');
    if (typeof removeTrapFocus === 'function') removeTrapFocus(this.activeElement);
  }
}

if (!customElements.get('wishlist-drawer')) {
  customElements.define('wishlist-drawer', WishlistDrawer);
}
